import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import { get } from '../../styles/constant';
const Message = styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: ", ";\n  margin-top: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"])), get('space.0'), get('space.4'), get('colors.feedback.danger.normal'), get('space.14'), get('space.20'));
const Components = {
  Message
};
export { Components };